import React, { useState } from "react";
import style from "./Inventory_panel.module.css";
import Manual_inventory_form from "./Manual_Inventory/Manual_inventory_form";
import Xlsinvinvonterytry from "./Xls_Inventory/Xlsinvinvonterytry";
import Showinventory from "./Show_Inventory/Showinventory";
import ProductMaster from "./Product_master/ProductMaster";
import ProductQuantity from "./Product_Quantity/ProductQuantity";


const Inventorypanel = () => {
  const [content, setContent] = useState("productList"); // Default is showing product list

  const manualContent = (
    <div>
      <div className="row">
        <Manual_inventory_form />
      </div>
    </div>
  );

  const xlsFormatContent = (
    <div>
      <Xlsinvinvonterytry />
    </div>
  );

  const productListContent = (
    <div>
      <Showinventory />
    </div>
  );

  const productmasterContent = (
    <div>
      <ProductMaster />
    </div>
  );

  const productquantityContent = (
    <div>
      <ProductQuantity />
    </div>
  );

  return (
    <>
      <div className="container-fluid">
        <div className={`${style.headingandbtn} row justify-content-center pb-0`}>
          <div className={`${style.companyname} col-auto mb-2 ${style.manual}`}>

            <h3 className={`${style.namea} m-0`}>
              {content === "productList" && "Product List"}
              {content === "productmaster" && "Product Master"}
              {content === "productquantity" && "Product Quantity"}
              {content === "manual" && "Add Manual"}
              {content === "xlsFormat" && "Add XLS"}
            </h3>
          </div>

          <div className={`${style.headingcolbtn} col mb-2`}>
            <div className={style.btnGrid}>

              <h3 className={style.xlsformat} onClick={() => setContent("productList")}>
                PRODUCT LIST
              </h3>

              <h3 className={style.xlsformat} onClick={() => setContent("productmaster")}>
                PRODUCT MASTER
              </h3>

              <h3 className={style.xlsformat} onClick={() => setContent("productquantity")}>
                PRODUCT QUANTITY
              </h3>

              <h3 className={style.aDD}>
                ADD INVENTORY <i class="fa-regular fa-circle-right"></i>
              </h3>


              <h3 className={style.manul} onClick={() => setContent("manual")}>
                MANUAL
              </h3>

              <h3 className={style.xlsformat} onClick={() => setContent("xlsFormat")}>
                XLS FORMAT
              </h3>
            </div>

          </div>
        </div>
        <hr className="mt-0 mb-2" />

        <div className={` ${style.contentrow} row`}>
          {content === "productList" && productListContent}
          {content === "productmaster" && productmasterContent}
          {content === "productquantity" && productquantityContent}
          {content === "manual" && manualContent}
          {content === "xlsFormat" && xlsFormatContent}
        </div>
      </div>
    </>
  );
};

export default Inventorypanel;
